<template>
  <div>
    <v-row>
        <v-col>
            <v-row align="center" justify="center" class="my-3 mx-10">
                <v-col cols="12" sm="5" md="5" xs="5" class="rounded-corners">
                    <v-card class="elevation-12 rounded-corners">
                        <v-toolbar :color="getThemeColor" dark flat>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                            <v-spacer />
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field v-if="!emailSent" label="Email Address" name="login" prepend-icon="person" type="text" placeholder="abc@example.com" v-model="userEmail" />
                               
                                    <v-btn 
                                    v-else
                                    text
                                    color="green" 
                                    for="password">Check your Inbox for link to reset your password</v-btn>
                                
                               
            
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn 
                            rounded 
                            small 
                            class="ml-8"
                            :color="getThemeColor" outlined 
                            style="margin-right: 20px;margin-bottom: 10px;" @click="routeTo('login')">
                                Go Back
                            </v-btn>
                            <v-spacer />
                            <v-btn 
                            v-if="!emailSent"
                            rounded dark small class="mr-4" :color="getThemeColor"  style="margin-right: 20px;margin-bottom: 10px;"
                                @click="resetPassword()">
                                Reset
                            </v-btn>
                            
                            
                            
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
 
  </div>
</template>

<script>
import helpers from "@/plugins/helpers"
import axios from "@/plugins/axios"

export default {
    mounted() { 
        this.link = window.origin +'/resetting-password?email='
    },
    computed: {
        getThemeColor() {
            return this.$store.getters.getThemeColor
        },
    },
    data: () => ({
        title: 'Password Reset',
        emailSent: false,
        userEmail: null,
        link: 'http://192.168.1.53:8080/resetting-password?email=',
    }),
    methods: {
        async resetPassword() { 
            const token = '&token=' + axios.generateToken()
            if (!this.userEmail) {
                alert('Enter a valid Email Address!')
                return
            } else {
                const res = await helpers.sendGeneralEmailNoToken(this.userEmail, 'BitsEMS Password Reset', 'Kindly click on the link to change your password to the BitsEMS school management system', this.link + this.userEmail + token, 'Click To Reset Password')
                if (res.status == 500) {
                    this.$toast.error('Oops, Something Went Wrong!')
                 } else {
                    this.$toast.success('Reset link sent successfully')
                    this.emailSent = true
                }  
            }
        },
        routeTo(pathName) { 
            this.$router.push({name:pathName})
        }
    }

}
</script>
